define("calendar/components/calendar/settings/bttp/report", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::CheckboxSwitch
    class="u--p__0 u--m__b at--bttpRetention__bttpToggleButton"
    @labelText={{t "bttp.toggle_title"}}
    @propertyToggled={{@bttpToggledOn}}
    @toggleAction={{@toggleBttp}}
  />
  <p class="u--text--light" data-test-id="bttp-toggle">
    {{#if @isLegacyBttp}}
      {{html-safe (t "bttp.toggle_details_legacy")}}
    {{else}}
      {{html-safe (t "bttp.toggle_details")}}
    {{/if}}
  </p>
  
  {{#if @bttpToggledOn}}
    {{#if @isLegacyBttp}}
      {{#unless @immediateBttpEnabled}}
        <p class="u--text--bold u--m__t__lg u--m__b__0">
          {{t "bttp.calculated_bttp" num=@numOfBttpTimeSlots nickname=@singleSocialProfile.displayNickname}}
        </p>
        <p class="u--text--light u--text--sm">
          {{@bttpLastCalculatedText}}
        </p>
      {{/unless}}
  
      <button
        type="button"
        class="o--btn o--btn--outline qa--generate_bttp_btn"
        {{on "click" (perform @triggerBttp true)}}
      >
        {{#if @immediateBttpEnabled}}
          {{t "bttp.enable_immediate_bttp"}}
        {{else}}
          {{t "bttp.recalculate"}}
        {{/if}}
      </button>
    {{else if (and @immediateBttpEnabled (not @isLegacyBttp))}}
      <button
        type="button"
        class="o--btn o--btn--outline qa--generate_bttp_btn"
        {{on "click" (perform @triggerBttp true)}}
      >
        {{t "bttp.recalculate"}}
      </button>
    {{/if}}
  {{/if}}
  
  {{#if @immediateBttpRolloutFlagEnabled}}
    {{#if @isOnLegacyPlan}}
      <Shared::CollapsableInfoCard @title={{t "bttp.switch_plan"}}>
        <p>{{t "bttp.new_and_improved"}}</p>
        <Shared::Link
          @text={{t "shared_phrases.learn_more"}}
          @href="https://help.later.com/hc/articles/360042771694-Find-Your-Best-Times-to-Post-on-Instagram"
        />
        <Shared::Button::Upgrade @feature="immediateBttp" @additional="block" @text={{t "shared_phrases.switch_plan"}} />
      </Shared::CollapsableInfoCard>
    {{else if (and @isLegacyBttp (not @immediateBttpEnabled))}}
      <Shared::CollapsableInfoCard @title={{t "bttp.feature_update_available"}}>
        <p class="u--m__b__0">{{t "bttp.100_followers_continue_use"}}</p>
        <Shared::Link
          @text={{t "shared_phrases.learn_more"}}
          @href="https://help.later.com/hc/articles/360042771694-Find-Your-Best-Times-to-Post-on-Instagram"
        />
      </Shared::CollapsableInfoCard>
    {{else}}
      <Shared::CollapsableInfoCard @title={{t "bttp.improved_feature"}}>
        <ul>
          <li>{{t "bttp.no_minimum_posts"}}</li>
          <li>{{t "bttp.more_accurate_timeslots"}}</li>
        </ul>
        <Shared::Link
          @text={{t "shared_phrases.learn_more"}}
          @href="https://help.later.com/hc/articles/360042771694-Find-Your-Best-Times-to-Post-on-Instagram"
        />
      </Shared::CollapsableInfoCard>
    {{/if}}
  {{/if}}
  
  */
  {
    "id": "kKq6y+eZ",
    "block": "[[[8,[39,0],[[24,0,\"u--p__0 u--m__b at--bttpRetention__bttpToggleButton\"]],[[\"@labelText\",\"@propertyToggled\",\"@toggleAction\"],[[28,[37,1],[\"bttp.toggle_title\"],null],[30,1],[30,2]]],null],[1,\"\\n\"],[10,2],[14,0,\"u--text--light\"],[14,\"data-test-id\",\"bttp-toggle\"],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"    \"],[1,[28,[35,3],[[28,[37,1],[\"bttp.toggle_details_legacy\"],null]],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,3],[[28,[37,1],[\"bttp.toggle_details\"],null]],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n\\n\"],[41,[30,1],[[[41,[30,3],[[[41,[51,[30,4]],[[[1,\"      \"],[10,2],[14,0,\"u--text--bold u--m__t__lg u--m__b__0\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"bttp.calculated_bttp\"],[[\"num\",\"nickname\"],[[30,5],[30,6,[\"displayNickname\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n        \"],[1,[30,7]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[11,\"button\"],[24,0,\"o--btn o--btn--outline qa--generate_bttp_btn\"],[24,4,\"button\"],[4,[38,5],[\"click\",[28,[37,6],[[30,8],true],null]],null],[12],[1,\"\\n\"],[41,[30,4],[[[1,\"        \"],[1,[28,[35,1],[\"bttp.enable_immediate_bttp\"],null]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,1],[\"bttp.recalculate\"],null]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,4],[28,[37,8],[[30,3]],null]],null],[[[1,\"    \"],[11,\"button\"],[24,0,\"o--btn o--btn--outline qa--generate_bttp_btn\"],[24,4,\"button\"],[4,[38,5],[\"click\",[28,[37,6],[[30,8],true],null]],null],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"bttp.recalculate\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]]],[]],null],[1,\"\\n\"],[41,[30,9],[[[41,[30,10],[[[1,\"    \"],[8,[39,9],null,[[\"@title\"],[[28,[37,1],[\"bttp.switch_plan\"],null]]],[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"bttp.new_and_improved\"],null]],[13],[1,\"\\n      \"],[8,[39,10],null,[[\"@text\",\"@href\"],[[28,[37,1],[\"shared_phrases.learn_more\"],null],\"https://help.later.com/hc/articles/360042771694-Find-Your-Best-Times-to-Post-on-Instagram\"]],null],[1,\"\\n      \"],[8,[39,11],null,[[\"@feature\",\"@additional\",\"@text\"],[\"immediateBttp\",\"block\",[28,[37,1],[\"shared_phrases.switch_plan\"],null]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,3],[28,[37,8],[[30,4]],null]],null],[[[1,\"    \"],[8,[39,9],null,[[\"@title\"],[[28,[37,1],[\"bttp.feature_update_available\"],null]]],[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,1],[\"bttp.100_followers_continue_use\"],null]],[13],[1,\"\\n      \"],[8,[39,10],null,[[\"@text\",\"@href\"],[[28,[37,1],[\"shared_phrases.learn_more\"],null],\"https://help.later.com/hc/articles/360042771694-Find-Your-Best-Times-to-Post-on-Instagram\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,9],null,[[\"@title\"],[[28,[37,1],[\"bttp.improved_feature\"],null]]],[[\"default\"],[[[[1,\"\\n      \"],[10,\"ul\"],[12],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,1],[\"bttp.no_minimum_posts\"],null]],[13],[1,\"\\n        \"],[10,\"li\"],[12],[1,[28,[35,1],[\"bttp.more_accurate_timeslots\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,10],null,[[\"@text\",\"@href\"],[[28,[37,1],[\"shared_phrases.learn_more\"],null],\"https://help.later.com/hc/articles/360042771694-Find-Your-Best-Times-to-Post-on-Instagram\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]],[]]]],[]],null]],[\"@bttpToggledOn\",\"@toggleBttp\",\"@isLegacyBttp\",\"@immediateBttpEnabled\",\"@numOfBttpTimeSlots\",\"@singleSocialProfile\",\"@bttpLastCalculatedText\",\"@triggerBttp\",\"@immediateBttpRolloutFlagEnabled\",\"@isOnLegacyPlan\"],false,[\"shared/ui/checkbox-switch\",\"t\",\"if\",\"html-safe\",\"unless\",\"on\",\"perform\",\"and\",\"not\",\"shared/collapsable-info-card\",\"shared/link\",\"shared/button/upgrade\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/report.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});